// `403 insufficient_role` (`spec/17-frontend.md` §4.3): a tela é esta, com logout.
// **Nunca** `/login`, o seller que caiu no host de admin entraria em laço.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { signOut } from '../api/auth.ts';
import { AuthShell } from '../components/app/auth-shell.tsx';
import { Button } from '../components/ui/button.tsx';

function NoAccess() {
  const queryClient = useQueryClient();
  const leave = useMutation({
    mutationFn: signOut,
    onSettled: () => {
      queryClient.clear();
      window.location.assign('/login');
    },
  });

  // Mesma moldura do login (`AuthShell`): quem cai aqui acabou de entrar, e a tela tem que
  // parecer o mesmo produto, não uma página de erro solta.
  return (
    <AuthShell
      title="Sem acesso a esta superfície"
      description="Esta conta não tem permissão para o painel deste endereço. Saia e entre com a conta certa."
    >
      <Button
        className="h-12 w-full"
        onClick={() => {
          leave.mutate();
        }}
        disabled={leave.isPending}
      >
        {leave.isPending ? 'Saindo…' : 'Sair'}
      </Button>
    </AuthShell>
  );
}

export const Route = createFileRoute('/no-access/')({ component: NoAccess });
